module.exports = __webpack_public_path__ + "img/networking.827df8d8.svg";